/* eslint-disable node/no-unsupported-features */
import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import theme from './theme';
import locale from './locale';
import telomere from './telomere';
import login from './login';
import post from './post';

export default combineReducers({
    router: routerReducer,
    theme,
    locale,
    telomere,
    post,
    login,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js